import { Component, inject } from '@angular/core';
import { LoadingService } from '../../../services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  template: `
    @if (loadingService.isLoading()) {
      <div class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/40 backdrop-blur-sm transition-all duration-300">
        <div class="bg-base-100 dark:bg-base-200 p-6 rounded-2xl shadow-2xl flex flex-col items-center gap-4 max-w-xs w-full mx-4 border border-base-300">
          <span class="loading loading-spinner loading-lg text-primary"></span>
          <p class="text-sm font-medium text-base-content text-center">
            {{ loadingService.message() }}
          </p>
        </div>
      </div>
    }
  `,
})
export class LoadingOverlayComponent {
  readonly loadingService = inject(LoadingService);
}
